// Vue.js Filters
// https://vuejs.org/v2/guide/filters.html

import Vue from 'vue'
import moment from 'moment'

let filters = {
  isPhoto(name) {
    return /\.(jpe?g|png|gif)$/i.test(name)
  },

  avatar(user) {
    if (!user) return ''
    if (user.photo) return user.photo.url
  },

  avatar500(user) {
    if (user.photo) return user.photo.url.replace('thumbnail200_', 'thumbnail500_')
  },

  originalPhoto(user) {
    if (user.photo) return user.photo.url.replace('thumbnail200_', '')
  },

  lastMessage(chatroom) {
    if (!chatroom.last_message) return ''
    return (chatroom.last_message.includes('attachments/') ? '画像を送信しました' : chatroom.last_message || '')
  },

  formatTimelineDateTime(date) {
    if (!date)
        return;
    
    date = moment.utc(date).local();
    let now = moment();
    let diff = moment.duration(now.diff(date));
    
    if (diff.asSeconds() < 60) return Math.floor(diff.asSeconds()) + '秒前';
    if (diff.asMinutes() < 60) return Math.floor(diff.asMinutes()) + '分前';
    if (diff.asHours() < 24) return Math.floor(diff.asHours()) + '時間前';
    if (diff.asDays() < 7) return Math.floor(diff.asDays()) + '日前';

    return date.format('MM/DD HH:mm');
  },

  formatDate(date){
    if(!date)
      return;

    return moment.utc(date).local().format('YYYY/MM/DD');
  },

  formatDotDate(date){
    if(!date)
      return;

    return moment.utc(date).local().format('YYYY.MM.DD');
  },

  formatDateTime(date){
    if(!date)
      return;

    return moment.utc(date).local().format('YYYY/MM/DD HH:mm');
  },

  formatShortDate(date){
    if(!date)
      return;

    return moment.utc(date).local().format('MM月DD日');
  },

  gender(gender) {
    if (gender == 1) return '男性'
    else if (gender == 2) return '女性'
    return ''
  },

  formatNumber(value) {
    value += '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(value)) {
        value = value.replace(rgx, '$1' + ',' + '$2');
    }
    return value;
  },

  formatSeconds(time) {
    var minutes = Math.floor(time / 60)
    var seconds = time - minutes * 60
    return `${minutes}分${seconds}秒`
  },

  ccAge(sitter) {
    var str = ''
    var y1 = parseInt(sitter.cc_age_from / 12)
    var m1 = sitter.cc_age_from - 12 * y1

    var y2 = parseInt(sitter.cc_age_to / 12)
    var m2 = sitter.cc_age_to - 12 * y2
    if (y1 > 0) str = `${y1}歳`
    if (m1 > 0) str += `${m1}ヶ月 ~ `
    if (y2 > 0) str += `${y2}歳`
    if (m2 > 0) str += `${m2}ヶ月`
    return str
  },

  childCnt(sitter) {
    return `1人 ~ ${sitter.child_cnt}人`
  },

  categories(sitter) {
    return sitter.categories.map(category => category.name).join(', ')
  }

}

// Register All Filters on import
Object.keys(filters).forEach(function (filterName) {
  Vue.filter(filterName, filters[filterName])
})
